"use client";

export default function HomeCall({ data }) {
  return (
    <section className="w-full bg-blue-700 h-auto md:h-[400px] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-[1440px] mx-auto text-center text-white flex flex-col items-center justify-center">
        <h2 className="font-bold text-[32px] sm:text-[40px] md:text-[30px] underline decoration-4 decoration-white mb-4">
          { data.contentField1 }
        </h2>
        <div className="font-thin text-[28px] sm:text-[45px] md:text-[35px] leading-tight mb-4">
          { data.contentField2 }
        </div>
        <div className="font-normal text-[22px] sm:text-[30px] md:text-[35px] leading-tight max-w-[1000px]">
          { data.contentField3 }
        </div>
      </div>
    </section>
  );
}
